import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../context/AppContext";
import { PageContent, QuestionnaireScreen } from "../../components";
import lwn_data from "../../data";
import Notification from "../../components/Notification";

const IdentifiedBarriers = () => {
  const navigate = useNavigate();
  const { getRankings, allAnswered, changeCurrentStep } = useContext(AppContext);
  const [currentQuestionnaireId, setCurrentQuestionnaireId] = useState(null);
  const [currentQuestionnaireIndex, setCurrentQuestionnaireIndex] = useState(0);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [ranking, setRanking] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false); // State for dialog visibility
  const { t } = useTranslation();

  useEffect(() => {
    const ranking = getRankings() || []; // Ensure ranking is not null or undefined
    setRanking(ranking);

    if (isFirstRender && ranking.length > 0) {
      const nextQuestionnaire = ranking.map((rank, index) => {
        const matchedQuestionnaire = lwn_data.find((q) => q.questionnaireType === rank.type);
        return {
          ...rank,
          priority: index + 1,
          questionnaireId: matchedQuestionnaire ? matchedQuestionnaire.questionnaireId : null,
          completed: matchedQuestionnaire
            ? allAnswered(matchedQuestionnaire.questionnaireId)
            : false,
        };
      });

      const nextIndexObj = nextQuestionnaire.find((q) => q.completed === false);
      // const nextIndex = nextIndexObj ? nextQuestionnaire.indexOf(nextIndexObj) : 0;
      const nextIndex = 0;

      setCurrentQuestionnaireIndex(nextIndex);
      setCurrentQuestionnaireId(
        lwn_data.find((q) => q.questionnaireType === ranking[nextIndex]?.type)?.questionnaireId ||
        null
      );
      setIsFirstRender(false);
    }
  }, [isFirstRender]);

  const handleNextClick = () => {
    // Check if current questionnaire is answered
    if (currentQuestionnaireId && !allAnswered(currentQuestionnaireId)) {
      setDialogOpen(true); // Show dialog if questions are unanswered
      return;
    }

    const nextIndex = currentQuestionnaireIndex + 1;
    if (nextIndex < ranking.length) {
      const nextQuestionnaire = ranking[nextIndex];
      const nextQuestionnaireId = lwn_data.find(
        (q) => q.questionnaireType === nextQuestionnaire?.type
      )?.questionnaireId;

      setCurrentQuestionnaireIndex(nextIndex);
      setCurrentQuestionnaireId(nextQuestionnaireId);
    } else {
      navigate("/ActionPlan");
      changeCurrentStep(4);
    }
  };

  const handleBackClick = () => {
    if (currentQuestionnaireIndex === 0) {
      navigate("/ScreeningResults");
      changeCurrentStep(2);
    } else {
      const previousIndex = currentQuestionnaireIndex - 1;
      const previousQuestionnaireId = lwn_data.find(
        (q) => q.questionnaireType === ranking[previousIndex]?.type
      )?.questionnaireId;

      setCurrentQuestionnaireIndex(previousIndex);
      setCurrentQuestionnaireId(previousQuestionnaireId);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog
  };

  var title = t("title_followup_strategy_questions");
  title = `${title} for Priority ${currentQuestionnaireIndex + 1} of ${ranking.length}`;

  return (
    <PageContent title={title}>
      {currentQuestionnaireId !== null && currentQuestionnaireId !== undefined && (
        <QuestionnaireScreen
          key={currentQuestionnaireId}
          questionnaireId={currentQuestionnaireId.toString()}
        />
      )}

      {/* Wrap the buttons in a Box to align them */}
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleBackClick}
          sx={{
            marginRight: "13px",
          }}
        >
          {t("button_back")}
        </Button>
        <Button variant="contained" color="primary" onClick={handleNextClick}>
          {t("button_next")}
        </Button>
      </Box>

      {/* Dialog for unanswered questions */}
      <Notification
        type="warning"
        message={t("please_answer_all_questions")}
        open={dialogOpen}
        onClose={handleCloseDialog}
        centered={true}
      />
    </PageContent>
  );
};

export default IdentifiedBarriers;
